const LOG_PREFIX = '[GET - Fetch Section By ID]';

const fetchSectionByIdFnKey = 'articles-by-section';

export default {
  LOG_PREFIX,
  fetchSectionByIdFnKey,
};
